<script>
	import Painel from './Painel.svelte';
	
	const opcoes = [
		{
			titulo: "Voltar", 
			icone: "voltar",
			link: "#/painel",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Executar", 
			icone: "play",
			link: "#/distribuicao/executar",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Conferir", 
			icone: "listar",
			link: "#/distribuicao/listagem",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Falhas (PROJ)", 
			icone: "aviso",
			link: "#/distribuicao/falhas-projeto",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Falhas (APRE)", 
			icone: "aviso",
			link: "#/distribuicao/falhas-apresentacao",
			perfis: "CETREINA"
		},
		{ 
		titulo: "Dist. manual", 
		icone: "indicar",
		link: "#/distribuicao/manual",
		perfis: "CETREINA"
		}
	];
</script>

<Painel 
	titulo="Painel de Distribuição" 
	listaFuncionalidades={opcoes}>
</Painel>
